import * as React from "react";
import Logo from "./logo";
import NavigationLinks from "./nav_links";
import SocialMediaIcons from "./social_media_icons";
import images from "./assets/images";

const Footer: React.FC = () => {
  return (
    <footer className="relative bg-primary text-white py-8 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap gap-10 items-start">
          <div className="w-full md:w-1/4 mb-6 md:mb-0 flex flex-col items-center">
            <div className="mb-4">
              <Logo />
            </div>
            <div className="w-full flex justify-center">
              <SocialMediaIcons />
            </div>
          </div>
          <div className="w-full md:w-1/2 mb-6 md:mb-0">
            <NavigationLinks />
          </div>
        </div>
        <div className="mt-8 text-center md:text-left text-sm text-grayOne">
          © DroneDen {new Date().getFullYear()}
        </div>
      </div>
      {/* Imaginea care se ascunde pe ecrane mici */}
      <img
        src={images.footerImage}
        alt="Footer Image"
        className="hidden sm:block absolute right-[-43px] bottom-[-284px]"
      />
    </footer>
  );
};

export default Footer;
